import toast from "react-hot-toast";

const notify = (label, type) => toast[type](label, {});

export default notify;
